import React from 'react';
import { Card, Table, Typography, Alert, Tag, Space } from 'antd';
import { ROLES, ROLE_LABEL } from '../../utils/role';
import './PermissionManager.css';

const { Title, Paragraph, Text } = Typography;

const BUILTIN_SUPER_ADMIN_LOGIN_ID = 'sysadmin';

const renderCell = (val) => {
    if (val === true) return <Tag color="success">允许</Tag>;
    if (val === false) return <Tag color="default">禁止</Tag>;
    return <Text type="secondary">{String(val)}</Text>;
};

const PERMISSION_MATRIX = [
    { action: '注册 / 登录', superAdmin: true, admin: true, user: true },
    { action: '查看用户列表', superAdmin: '全部用户', admin: '仅普通用户', user: false },
    { action: '查看用户详情', superAdmin: '全部', admin: '普通用户 + 自己', user: '仅自己' },
    { action: '新建用户 POST /create', superAdmin: 'ADMIN / USER', admin: '仅 USER', user: false },
    { action: '更新用户', superAdmin: '全部 + 自己', admin: 'USER + 自己', user: '仅自己' },
    { action: '删除用户', superAdmin: '✓（不可删自己/超管）', admin: '仅 USER', user: false },
    { action: '授权管理员 grant', superAdmin: 'USER→ADMIN', admin: false, user: false },
    { action: '撤销管理员 revoke', superAdmin: 'ADMIN→USER', admin: false, user: false },
];

const columns = [
    { title: '操作', dataIndex: 'action', width: 220 },
    {
        title: ROLE_LABEL[ROLES.SUPER_ADMIN],
        dataIndex: 'superAdmin',
        render: renderCell,
    },
    {
        title: ROLE_LABEL[ROLES.ADMIN],
        dataIndex: 'admin',
        render: renderCell,
    },
    {
        title: ROLE_LABEL[ROLES.USER],
        dataIndex: 'user',
        render: renderCell,
    },
];

class PermissionManager extends React.Component {
    render() {
        return (
            <div className="permission-manager">
                <Card bordered={false}>
                    <Title level={4}>角色与权限说明</Title>
                    <Paragraph type="secondary">
                        系统采用三级 RBAC：超级管理员（全局唯一）、管理员、普通用户。
                        用户授权与撤销请在「用户账号管理」中操作；操作后对方需重新登录以刷新 Token 中的角色。
                    </Paragraph>
                    <Alert
                        type="info"
                        showIcon
                        className="permission-manager__builtin-alert"
                        style={{ marginBottom: 20 }}
                        message="内置超级管理员说明"
                        description={
                            <div className="permission-manager__builtin-desc">
                                <Space wrap size={[8, 4]}>
                                    <span>
                                        登录名：<Text code>{BUILTIN_SUPER_ADMIN_LOGIN_ID}</Text>
                                    </span>
                                    <span>
                                        角色：
                                        <Tag color="gold">{ROLE_LABEL[ROLES.SUPER_ADMIN]}</Tag>
                                    </span>
                                </Space>
                                <Paragraph type="secondary" className="permission-manager__builtin-hint">
                                    密码在系统部署或首次初始化时设定，出于安全考虑不在此页面展示；修改密码后请使用新密码登录。
                                </Paragraph>
                            </div>
                        }
                    />
                    <Table
                        rowKey="action"
                        columns={columns}
                        dataSource={PERMISSION_MATRIX}
                        pagination={false}
                        size="middle"
                        scroll={{ x: 'max-content' }}
                    />
                </Card>
            </div>
        );
    }
}

export default PermissionManager;
